<template>
  <v-row dense justify="center" align="center">
    <v-col cols="12" sm="12">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-tooltip v-if="!show" top color="black">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error"> mdi-alert-circle </v-icon>
                </template>
                <span>{{
                  $t("messanger.dash.filters.state_mode.warning")
                }}</span>
              </v-tooltip>
              <v-tooltip v-if="required" top color="black">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="warning"> mdi-alert-circle </v-icon>
                </template>
                <span>{{
                  $t("messanger.dash.filters.state_mode.required")
                }}</span>
              </v-tooltip>
              <v-icon v-else color="success"> mdi-check-circle </v-icon>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-btn x-small icon class="mr-2" disabled>
                        <v-img src="@/assets/moon.svg" class="filters-icons" />
                      </v-btn>
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.filters.state_mode.name") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">
                      {{
                        $t("messanger.dash.filters.state_mode.select_choise")
                      }}
                    </span>
                    <span v-else key="1">
                      {{
                        selected_mode
                          ? $t(
                              `messanger.dash.filters.Bot_Human_mode.${selected_mode}`
                            )
                          : ""
                      }}
                      {{
                        chat_state
                          ? `, ${$t(
                              `messanger.dash.filters.state_mode.${chat_state}`
                            )}`
                          : ""
                      }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group
              @change="mode_change"
              v-model="selected_mode"
              columns
              light
              :disabled="!show"
            >
              <v-row dense justify="center" align="center">
                <v-col cols="auto">
                  <v-radio
                    :label="$t('messanger.dash.filters.Bot_Human_mode.auto')"
                    color="#1141ce"
                    value="auto"
                    class="px-3"
                    disabled
                  ></v-radio>
                </v-col>
                <v-col cols="auto">
                  <v-radio
                    :label="$t('messanger.dash.filters.Bot_Human_mode.manual')"
                    color="#1141ce"
                    value="manual"
                    class="px-3"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>

            <v-row no-gutters justify="center" align="center">
              <v-col cols="12" sm="8" v-if="selected_mode === 'manual'">
                <v-select
                  light
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="chat_state"
                  :items="items"
                  @change="change_state"
                  :disabled="!show"
                >
                  <template v-slot:label>
                    <v-icon size="28" class="mx-1" color="black">
                      mdi-theme-light-dark
                    </v-icon>
                    {{ $t("messanger.dash.filters.state_mode.name") }}
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    {{ $t(`messanger.dash.filters.state_mode.${item.text}`) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t(`messanger.dash.filters.state_mode.${item.text}`) }}
                  </template>
                </v-select>
              </v-col>

              <v-col v-if="selected_mode === 'auto'" cols="12">
                <v-fade-transition hide-on-leave>
                  <DateSet />
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import DateSet from "./StatusChatDate";

export default {
  name: "StateMode",
  components: {
    DateSet,
  },
  data: () => ({
    chat_state: null,
    panel_open: false,
    selected_mode: null,
    modes: {
      bot: [
        { text: "active_human", value: "active" },
        { text: "active_human_ask_email", value: "active_ask_email" },
        { text: "no_active_human_ask_email", value: "no_active_ask_email" },
        { text: "no_active_human", value: "no_active" },
      ],
      human: [
        { text: "active", value: "active" },
        { text: "no_active", value: "no_active" },
      ],
    },
    items: [],
  }),
  computed: {
    config() {
      return this.$store.state.store_config.store.chat_config;
    },
    show() {
      if (
        this.config?.chat_mode?.state == "bot" ||
        this.config?.chat_mode?.state == "human"
      ) {
        this.set_modes();
        return true;
      }
      return false;
    },
    required() {
      if (!this.config?.chat_state?.state || !this.config?.chat_state?.mode)
        return true;
      return false;
    },
  },
  watch: {
    config(value) {
      this.update_config();
    },
  },
  mounted() {
    this.update_config();
  },
  methods: {
    update_config() {
      if (this.config?.chat_state?.mode) {
        if (this.config?.chat_state?.mode === "manual")
          this.selected_mode = "manual";
        else if (this.config?.chat_state?.mode === "auto")
          this.selected_mode = "auto";
        else this.selected_mode = null;
        this.chat_state = this.config.chat_state.state || null;
      } else {
        this.selected_mode = null;
        this.chat_state = null;
      }
    },
    set_modes() {
      this.items = this.modes[this.config.chat_mode.state];
    },
    async mode_change() {
      try {
        const mode = this.selected_mode;
        console.log("selected mode", mode);
        const confirmation = await this.$store.dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.agree"),
          ligth: false,
        });
        if (!confirmation) {
          this.selected_mode = this.config.chat_state.mode;
          return;
        }
        if (mode === "manual") {
          this.config.chat_state = {};
        }
        this.config.chat_state = {
          ...this.config.chat_state,
          mode,
        };
        const new_config = await this.$store.dispatch("UPDATE_CHAT_CONFIG", {
          chat_config: this.config,
        });
        if (new_config) {
          this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", new_config);
        }
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: `${this.$t(
            "messanger.dash.filters.Bot_Human_mode.name"
          )} :  ${this.$t(`messanger.dash.filters.Bot_Human_mode.${mode}`)}`,
          color: "success",
          timeout: 2000,
        });
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: error.response.data,
          color: "error",
          timeout: 1000,
        });
      }
    },
    async change_state() {
      try {
        const chat_state = this.chat_state;
        const confirmation = await this.$store.dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.agree"),
          ligth: false,
        });
        if (!confirmation) {
          this.chat_state = this.config.chat_state.state;
          return;
        }
        this.config.chat_state = {
          ...this.config.chat_state,
          state: chat_state,
        };
        const new_config = await this.$store.dispatch("UPDATE_CHAT_CONFIG", {
          chat_config: this.config,
        });
        if (new_config) {
          this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", new_config);
        }
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: `${this.$t(
            "messanger.dash.filters.state_mode.name"
          )} :  ${this.$t(`messanger.dash.filters.state_mode.${chat_state}`)}`,
          color: "success",
          timeout: 2000,
        });
      } catch (error) {
        console.log(error);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: error.response.data,
          color: "error",
          timeout: 1000,
        });
      }
    },
  },
};
</script>
